import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/fonts/font.css";
import axios from "axios";
import MetaInfo from "vue-meta-info";

Vue.use(ElementUI);
Vue.use(MetaInfo);

axios
  .get(
    // "http://114.116.221.105:9090/gateway/ApiService/api/v3/customer/service/info/H5?source=EkeCash"
    "https://api.ekecash.pe/gateway/ApiService/api/v3/customer/service/info/H5?source=EkeCash",
  )
  .then(({ data }) => {
    localStorage.setItem('customerData', JSON.stringify(data.data))
  });

Vue.config.productionTip = false;


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
